module.exports = __webpack_public_path__ + "img/4.60d62f4e.jpg";